import React, {useState, useEffect} from "react"
import {MDBRow, MDBCol} from 'mdbreact'
import classes from './LoginPage.module.css'
import firebase from "../../Config/firebase";
import StyledFirebaseAuth from 'react-firebaseui/StyledFirebaseAuth'
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";
import {Helmet} from "react-helmet";
const uiConfig = {
    signInFlow: 'popup',
    signInOptions: [
        firebase.auth.GoogleAuthProvider.PROVIDER_ID,
        firebase.auth.EmailAuthProvider.PROVIDER_ID,
    ],
    callbacks: {
        signInSuccess: (props) => {
            console.log(props)
        }
    }
}

const LoginPage = (props) => {

    return (
        <>
            <MDBRow>
                <h2 className={classes.H2}>非Admin請不要登入，登入後沒有更多的功能。</h2>
                <MDBCol xl="12" lg="12" md="12" sm="12" xs="12">
                    <StyledFirebaseAuth uiConfig={uiConfig} firebaseAuth={firebase.auth()}/>
                </MDBCol>
            </MDBRow>
        </>
    )

}
const enhance = connect(
    ({firebase: {auth, profile}}) => ({
        auth,
        profile
    })
)

export default enhance(withRouter(LoginPage))

